// Sedan Hero Video
import heroVideoSedanDesktop from "../../../assets/videos/sedan-hero-desktop.mp4";
import heroVideoSedanMobile from "../../../assets/videos/sedan-hero-mobile.mp4";
// Sedan carousel images
import sedanBackDesktop from "../../../assets/img/models/sedan/carousel/sedan-back-desktop.webp";
import sedanBackMobile from "../../../assets/img/models/sedan/carousel/sedan-back-mobile.webp";
import sedanFrontDesktop from "../../../assets/img/models/sedan/carousel/sedan-front-desktop.webp";
import sedanFrontMobile from "../../../assets/img/models/sedan/carousel/sedan-front-mobile.webp";
import sedanSideDesktop from "../../../assets/img/models/sedan/carousel/sedan-side-desktop.webp";
import sedanSideMobile from "../../../assets/img/models/sedan/carousel/sedan-side-mobile.webp";
// Sedan exterior images
import sedanExteriorFront from "../../../assets/img/models/sedan/exterior/sedan-exterior-1.webp";
import sedanExteriorRear from "../../../assets/img/models/sedan/exterior/sedan-exterior-2.webp";
import sedanExteriorWheel from "../../../assets/img/models/sedan/exterior/sedan-exterior-3.webp";
import sedanExteriorMirror from "../../../assets/img/models/sedan/exterior/sedan-exterior-4.webp";
import sedanExteriorGrille from "../../../assets/img/models/sedan/exterior/sedan-exterior-5.webp";
import sedanExteriorFrontMobile from "../../../assets/img/models/sedan/exterior/sedan-exterior-1-mobile.webp";
import sedanExteriorRearMobile from "../../../assets/img/models/sedan/exterior/sedan-exterior-2-mobile.webp";
import sedanExteriorWheelMobile from "../../../assets/img/models/sedan/exterior/sedan-exterior-3-mobile.webp";
import sedanExteriorMirrorMobile from "../../../assets/img/models/sedan/exterior/sedan-exterior-4-mobile.webp";
import sedanExteriorGrilleMobile from "../../../assets/img/models/sedan/exterior/sedan-exterior-5-mobile.webp";
// Sedan interior images
import sedanInteriorSeats from "../../../assets/img/models/sedan/interior/sedan-interior-1.webp";
import sedanInteriorPanel from "../../../assets/img/models/sedan/interior/sedan-interior-2.webp";
import sedanInteriorKeys from "../../../assets/img/models/sedan/interior/sedan-interior-3.webp";
import sedanInteriorAirConditioner from "../../../assets/img/models/sedan/interior/sedan-interior-4.webp";
import sedanInteriorTrunk from "../../../assets/img/models/sedan/interior/sedan-interior-6.webp";
import sedanInteriorGears from "../../../assets/img/models/sedan/interior/sedan-interior-5.webp";
import sedanInteriorPanelMobile from "../../../assets/img/models/sedan/interior/sedan-interior-2-mobile.webp";
import sedanInteriorKeysMobile from "../../../assets/img/models/sedan/interior/sedan-interior-3-mobile.webp";
import sedanInteriorAirConditionerMobile from "../../../assets/img/models/sedan/interior/sedan-interior-4-mobile.webp";
import sedanInteriorTrunkMobile from "../../../assets/img/models/sedan/interior/sedan-interior-6-mobile.webp";
import sedanInteriorSeatsMobile from "../../../assets/img/models/sedan/interior/sedan-interior-1-mobile.webp";
import sedanInteriorGearsMobile from "../../../assets/img/models/sedan/interior/sedan-interior-5-mobile.webp";
// Sedan Atributes
import sedanAtributesDesktop from "../../../assets/img/models/sedan/atributes/sedan-atributes-desktop.webp";
import sedanAtributesMobile from "../../../assets/img/models/sedan/atributes/sedan-atributes-mobile.webp";
// Sedan Etiqueta
import sedanEtiqueta from "../../../assets/etiquetas/Etiqueta K3 Sedan EX_GT.pdf";
// Sedan Fichas
import sedanFichas from "../../../assets/fichas/Ficha técnica K3 Sedan EX_GT.pdf";

export const sedanImages = {
  carousel: {
    front: {
      desktop: sedanFrontDesktop,
      mobile: sedanFrontMobile,
    },
    back: {
      desktop: sedanBackDesktop,
      mobile: sedanBackMobile,
    },
    side: {
      desktop: sedanSideDesktop,
      mobile: sedanSideMobile,
    },
  },
  exterior: {
    front: {
      desktop: sedanExteriorFront,
      mobile: sedanExteriorFrontMobile,
    },
    rear: {
      desktop: sedanExteriorRear,
      mobile: sedanExteriorRearMobile,
    },
    wheel: {
      desktop: sedanExteriorWheel,
      mobile: sedanExteriorWheelMobile,
    },
    mirror: {
      desktop: sedanExteriorMirror,
      mobile: sedanExteriorMirrorMobile,
    },
    grille: {
      desktop: sedanExteriorGrille,
      mobile: sedanExteriorGrilleMobile,
    },
  },
  interior: {
    panel: {
      desktop: sedanInteriorPanel,
      mobile: sedanInteriorPanelMobile,
    },
    keys: {
      desktop: sedanInteriorKeys,
      mobile: sedanInteriorKeysMobile,
    },
    airConditioner: {
      desktop: sedanInteriorAirConditioner,
      mobile: sedanInteriorAirConditionerMobile,
    },
    trunk: {
      desktop: sedanInteriorTrunk,
      mobile: sedanInteriorTrunkMobile,
    },
    gears: {
      desktop: sedanInteriorGears,
      mobile: sedanInteriorGearsMobile,
    },
    seats: {
      desktop: sedanInteriorSeats,
      mobile: sedanInteriorSeatsMobile,
    },
  },
  attributes: {
    desktop: sedanAtributesDesktop,
    mobile: sedanAtributesMobile,
  },
  heroVideo: {
    desktop: heroVideoSedanDesktop,
    mobile: heroVideoSedanMobile,
  },
  etiqueta: sedanEtiqueta,
  fichas: sedanFichas,
};
